/// *** System import ***///
import { Component, ViewChild } from '@angular/core';
import { Content, PopoverController, ToastController } from 'ionic-angular';
import { RESOURCE_CACHE_PROVIDER } from '@angular/platform-browser-dynamic';
/// *** Custom import ***///
import { Globals } from '../../../app/globals';
import { SessionProvider } from '../../../providers/session';
import { Account_TransactionHistoryStore } from './transactionHistory.store';
import { Account_TransactionHistoryParamsPopover } from './popovers/params/params';

@Component({
  selector: 'page-account-transactionHistory',
  templateUrl: 'transactionHistory.html',
})
export class Account_TransactionHistoryPage {
  @ViewChild(Content) private content: Content;
  private isBuzy = true;
  private isProcessing = false;
  constructor(
    // *** System
    private popoverCtrl: PopoverController,
    private toastCtrl: ToastController,
    // *** Custom
    private globals: Globals,
    private session: SessionProvider,
    private store: Account_TransactionHistoryStore) {
    let startDate = new Date();
    startDate.setDate(1);
    this.store.configParams(
      {
        account: this.session.data.activeAccount,
        startDate: startDate,
        endDate: new Date(),
        showSearch: false,
      }, false);
  }

  // *** Evénement de chargement
  ngOnInit() {
    try {
      this.isBuzy = true;
      this.store.loadParams().then(
        (succeed) => {
          this.store.load().then(
            (succeed) => {
              this.isBuzy = false;
              this.content.resize();
            },
            (error) => { this.isBuzy = false; }
          );
        },
        (error) => { this.isBuzy = false; }
      );
    }
    catch (error) {
      this.isBuzy = false;
      this.globals.showUnknownError(this.toastCtrl, error);
    }
  }

  // *** Evénement de clôture
  ionViewWillUnload() {
    try {
      this.store.reset();
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
    }
  }

  // *** Afficher/Cacher la barre de recherche
  private _toggleSearch() {
    try {
      this.store.params.showSearch = !this.store.params.showSearch;
      if (!this.store.params.showSearch)
        this.store.search(null);
      this.content.resize();
      this.store.persistParams();
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
    }
  }

  // *** Recherche dans la liste des instruments
  private _doSearch(ev) {
    try {
      this.store.search(ev);
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
    }
  }

  // Afficher la fenêtre de paramètres
  private _presentParams(ev) {
    try {
      let popover = this.popoverCtrl.create(Account_TransactionHistoryParamsPopover);
      popover.present({ ev: ev });
      popover.onDidDismiss(
        (data) => {
          try {
            this.isBuzy = true;
            this.store.load(true).then(
              (result) => {
                this.isBuzy = false;
                this.content.resize();
                this.content.scrollToTop();
              },
              (error) => { this.isBuzy = false; }
            );
          }
          catch (error) {
            this.isBuzy = false;
            this.globals.showUnknownError(this.toastCtrl, error);
          }
        });
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
    }
  }

  // *** Recharger les données
  private _doRefresh(refresher) {
    try {
      this.isBuzy = true;
      this.store.load(true).then(
        (result) => {
          refresher.complete();
          this.content.resize();
          this.content.scrollToTop();
          this.isBuzy = false;
        },
        (error) => {
          refresher.complete();
          this.isBuzy = false;
        }
      );
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
      refresher.complete();
      this.isBuzy = false;
    }
  }

  // *** Afficher/Cacher les détails
  private _toggleDetails(order: any) {
    try {
      order.ShowDetails = !order.ShowDetails;
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/account/transactionHistory/transactionHistory.ts